import React, { useCallback, memo } from 'react';
import { Copy, Share2 } from 'lucide-react';
import { NodeType, NodeStatus } from '@/types';

interface ExportActionsProps {
  nodeId: string;
  nodeType: NodeType;
  status: NodeStatus;
  hasMedia: boolean;
  mediaUrl?: string;
  mediaType?: 'image' | 'video' | 'audio';
  onCopyToClipboard?: (nodeId: string, url: string) => void;
  onShare?: (nodeId: string) => void;
}

const ExportActionsInner: React.FC<ExportActionsProps> = ({
  nodeId,
  nodeType,
  status,
  hasMedia,
  mediaUrl,
  mediaType,
  onCopyToClipboard,
  onShare,
}) => {
  const handleCopy = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    if (onCopyToClipboard && mediaUrl) {
      onCopyToClipboard(nodeId, mediaUrl);
    }
  }, [nodeId, mediaUrl, onCopyToClipboard]);

  const handleShare = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    if (onShare) {
      onShare(nodeId);
    }
  }, [nodeId, onShare]);

  if (!hasMedia || !mediaUrl) return null;

  return (
    <>
      {onCopyToClipboard && mediaType === 'image' && (
        <button
          onClick={handleCopy}
          onMouseDown={(e) => e.stopPropagation()}
          title="复制到剪贴板"
          className="flex items-center justify-center w-9 h-9 rounded-md bg-transparent text-white hover:bg-white/15 transition-all cursor-pointer"
        >
          <Copy size={18} />
        </button>
      )}
      {onShare && (
        <button
          onClick={handleShare}
          onMouseDown={(e) => e.stopPropagation()}
          title="分享"
          className="flex items-center justify-center w-9 h-9 rounded-md bg-transparent text-white hover:bg-white/15 transition-all cursor-pointer"
        >
          <Share2 size={18} />
        </button>
      )}
    </>
  );
};

export const ExportActions = memo(ExportActionsInner);
